module.exports = __webpack_public_path__ + "img/Placeholder_video.62a75cc3.jpg";